import { createFileRoute, useNavigate } from "@tanstack/react-router";

import { OrderDocumentsExportPageConnector } from "@pages/order-documents-export";

export const Route = createFileRoute("/_private/orders/documents")({
  component: RouteComponent,
});

function RouteComponent() {
  const navigate = useNavigate();

  return (
    <OrderDocumentsExportPageConnector
      onBack={() => navigate({ to: "/transactions" })}
    />
  );
}
